import { MemberInsuranceStatus, MemberInsuranceViewModel, PaymentReceipt, SelectedPremiumInfo, SubscriptionFormViewModel, SubscriptionNoticePreselection, SubscriptionPeriod } from "./subscription.model";

//form
export class LoadSubscriptionForm {
  static readonly type = '[Subscription] LoadSubscriptionForm';
  constructor(public periodId: string, public subscriptionNoticeId: string, public memberId: string) { }
}
export class LoadSubscriptionFormSuccess {
  static readonly type = '[Subscription] LoadSubscriptionFormSuccess';
  constructor(public data: SubscriptionFormViewModel) { }
}
export class LoadSubscriptionFormFailure {
  static readonly type = '[Subscription] LoadSubscriptionFormFailure';
  constructor(public error: any) { }
}

//periods
export class LoadSubscriptionPeriods {
  static readonly type = '[Subscription] LoadSubscriptionPeriods';
  constructor(public memberId: string) { }
}
export class LoadSubscriptionPeriodsSuccess {
  static readonly type = '[Subscription] LoadSubscriptionPeriodsSuccess';
  constructor(public data: SubscriptionPeriod[]) { }
}
export class LoadSubscriptionPeriodsFailure {
  static readonly type = '[Subscription] LoadSubscriptionPeriodsFailure';
  constructor(public error: any) { }
}

//payment
export class ProceedSubscriptionPayment {
  static readonly type = '[Subscription] ProceedSubscriptionPayment';
  constructor( public selectedPremiumInfo: SelectedPremiumInfo) { }
}
export class ProceedSubscriptionPaymentSuccess {
  static readonly type = '[Subscription] ProceedSubscriptionPaymentSuccess';
  constructor(public data: PaymentReceipt) { }
}
export class ProceedSubscriptionPaymentFailure {
  static readonly type = '[Subscription] ProceedSubscriptionPaymentFailure';
  constructor(public error: any,  public selectedPremiumInfo: SelectedPremiumInfo) { }
}

//memberId
export class LoadMemberId {
  static readonly type = '[Subscription] LoadMemberId';
  constructor(public permitNumber: string) { }
}
export class LoadMemberIdSuccess {
  static readonly type = '[Subscription] LoadMemberIdSuccess';
  constructor(public data: string) { }
}
export class LoadMemberIdFailure {
  static readonly type = '[Subscription] LoadMemberIdFailure';
  constructor(public error: any) { }
}

export class SeeParticularConditions {
  static readonly type = '[Subscription] SeeParticularConditions';
  constructor(
    public memberId: string,
    public financialYear: number,
    public permitNumber: string
  ) {}
}

export class SeeParticularConditionsSuccess {
  static readonly type = '[Subscription] SeeParticularConditionsSuccess';
  constructor(
    public data: any,
    public financialYear: number,
    public permitNumber: string
  ) {}
}

export class SeeParticularConditionsFailure {
  static readonly type = '[Subscription] SeeParticularConditionsFailure';
  constructor(public error: any) {
    console.log(error);
  }
}

export class SeeSubscriptionReceipt {
  static readonly type = '[Subscription] SeeSubscriptionReceipt';
  constructor(
    public memberId: string,
    public id: string,
    public description: string,
    public permitNumber: string
  ) {}
}

export class SeeSubscriptionReceiptSuccess {
  static readonly type = '[Subscription] SeeSubscriptionReceiptSuccess';
  constructor(
    public data: any,
    public id: string,
    public description: string,
    public permitNumber: string
  ) {}
}

export class SeeSubscriptionReceiptFailure {
  static readonly type = '[Subscription] SeeSubscriptionReceiptFailure';
  constructor(public error: any) {
    console.log(error);
  }
}

//Load SouscriptionStatut by memberId 
export class LoadSubscriptionStatus {
  static readonly type = '[Subscription] LoadSubscriptionStatus';
  constructor(public memberId: string) { }
}
export class LoadSubscriptionStatusSuccess {
  static readonly type = '[Subscription] LoadSubscriptionStatusSuccess';
  constructor(public data: MemberInsuranceViewModel[]) { }
}
export class LoadSubscriptionStatusFailure {
  static readonly type = '[Subscription] LoadSubscriptionStatusFailure';
  constructor(public error: any) { }
}
export class AddMemberInsuranceStatus {
  constructor(
    public memberId: string,
    public insuranceStatus: MemberInsuranceStatus,
  ) {}
  static readonly type = '[Subscription] AddMemberInsuranceStatus';
}
export class AddMemberInsuranceStatusSuccess {
  static readonly type = '[Subscription] AddMemberInsuranceStatusSuccess';
}
export class AddMemberInsuranceStatusFailure {
  static readonly type = '[Subscription] AddMemberInsuranceStatusFailure';
  constructor(public error: any) {}
}
//reclamation validation
export class ReportReclamationValidation {
  static readonly type = '[Subscription] ReportReclamationValidation';
  constructor(
    public memberId: string,
    public isReclamationReported: boolean,
    public surplusPremiumId: string,
    public financialYear: number,
    public subscriptionNoticeId: string
  ) {} 
}
export class ReportReclamationValidationSuccess {
  static readonly type = '[Subscription] ReportReclamationValidationSuccess';
  constructor(public subscriptionNoticePreselection: SubscriptionNoticePreselection) {}
}
export class ReportReclamationValidationFailure {
  static readonly type = '[Subscription] ReportReclamationValidationFailure';
  constructor(public error: any) {}
}